import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'targetBlank' })
export class TargetBlankPipe implements PipeTransform {
  transform(text: string): string {
    return text.split('<a').join('<a target="_blank"');
  }
}
